import { render, staticRenderFns } from "./ExchangeRateForm.vue?vue&type=template&id=6d4b6772"
import script from "./ExchangeRateForm.vue?vue&type=script&lang=js"
export * from "./ExchangeRateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports